import {
  COVERAGE_AREA_TYPE,
  isDealerStoreType,
  isDriverStoreType,
} from "types/coverageAreaType";

export const PLACED_ORIGIN = {
  DRIVER_STORE: "DriverStore",
  DEALER_STORE: "DealerStore",
} as const;

type OrderDriverInfo = {
  id?: string;
  name?: string;
  surname?: string;
};

type OrderCoverageAreaInfo = {
  name?: string;
  areaType?: string;
};

function trimValue(value?: string): string {
  return (value ?? "").trim();
}

function buildDriverFullName(driver?: OrderDriverInfo | null): string {
  return [trimValue(driver?.name), trimValue(driver?.surname)]
    .filter(Boolean)
    .join(" ");
}

export function getOrderDeliveryPersonDisplayName(params: {
  driver?: OrderDriverInfo | null;
  coverageArea?: OrderCoverageAreaInfo | null;
}): string {
  const driverFullName = buildDriverFullName(params.driver);
  if (driverFullName) {
    return driverFullName;
  }

  if (isDriverStoreType(params.coverageArea?.areaType)) {
    return trimValue(params.coverageArea?.name);
  }

  return "";
}

export function hasAssignedOrderDriver(
  driver?: OrderDriverInfo | null,
  coverageArea?: OrderCoverageAreaInfo | null,
): boolean {
  if (
    getOrderDeliveryPersonDisplayName({
      driver,
      coverageArea,
    })
  ) {
    return true;
  }

  return Boolean(trimValue(driver?.id));
}

export function canSelectDriverInOrderDetails(
  placedOrigin?: string,
  isFinalizedTab = false,
): boolean {
  if (isFinalizedTab) {
    return false;
  }

  return placedOrigin !== PLACED_ORIGIN.DEALER_STORE;
}

export function canChangeDriverInOrderDetails(
  placedOrigin?: string,
  isFinalizedTab = false,
): boolean {
  if (isFinalizedTab) {
    return false;
  }

  return placedOrigin !== PLACED_ORIGIN.DEALER_STORE;
}

export function shouldDisableOrderDriverSectionBorder(
  placedOrigin?: string,
): boolean {
  return placedOrigin === PLACED_ORIGIN.DEALER_STORE;
}

export function canManageCoverageAreaDriver(
  coverageAreaType?: string,
): boolean {
  return !isDealerStoreType(coverageAreaType);
}

export { COVERAGE_AREA_TYPE };
